import {
    ApplicationConfig,
    importProvidersFrom,
    mergeApplicationConfig,
    TransferState,
} from "@angular/core";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { TranslateLoader, TranslateModule } from "@ngx-translate/core";

import {
    ENV_CONFIG,
    HTTP_REQUEST_TIMEOUT,
    REQUEST,
    RESPONSE,
} from "@hermes/core-app-core";
import { LogConfig, LogLevel } from "@hermes/logger";
import { BrowserTranslationLoader, browserEnvConfig } from "@hermes/core-web-custom";
import { LOGGER_CONFIG } from "@hermes/core-web-logger";

import { environment } from "../environments/environment";

import { appConfig } from "./app.config";

const browserConfig: ApplicationConfig = {
    providers: [
        importProvidersFrom(
            BrowserAnimationsModule,
            TranslateModule.forRoot({
                loader: {
                    provide: TranslateLoader,
                    useClass: BrowserTranslationLoader,
                },
            }),
        ),
        {
            provide: REQUEST,
            useValue: undefined,
        },
        {
            provide: RESPONSE,
            useValue: undefined,
        },
        {
            provide: ENV_CONFIG,
            useFactory: (transferState: TransferState) =>
                browserEnvConfig(transferState, {
                    RDR_BACKEND_HOSTS_FROM_BUILD_ENV:
                        environment.rdrBackendHost,
                }),
            deps: [TransferState],
        },
        {
            provide: LOGGER_CONFIG,
            useValue: {
                level: environment.production ? LogLevel.Emerg : LogLevel.Trace,
                appenders: {
                    console: { type: "console" },
                },
            } as LogConfig,
        },
        {
            provide: HTTP_REQUEST_TIMEOUT,
            useValue: 180_000,
        },
    ],
};

export const appBrowserConfig = mergeApplicationConfig(
    appConfig,
    browserConfig,
);
